"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const utils_1 = require("utils");
const reducer_1 = require("../reducer");
const ApprovalAdvantage_1 = __importDefault(require("./ApprovalAdvantage"));
const ApprovalCard_1 = __importDefault(require("./ApprovalCard"));
const ApprovalInstallment_1 = __importDefault(require("./ApprovalInstallment"));
function Approval({ personalInfo, practice, approvedApplication, lenderName, }) {
    const { applicationServiceProviderPriority } = approvedApplication;
    (0, react_1.useEffect)(() => {
        (0, utils_1.scrollToTop)();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [lenderName == 'Imprint' && ((0, jsx_runtime_1.jsx)(ApprovalAdvantage_1.default, { practice: practice, approvedApplication: approvedApplication })), applicationServiceProviderPriority.productType == 'line_of_credit' && ((0, jsx_runtime_1.jsx)(ApprovalCard_1.default, { personalInfo: personalInfo, practice: practice, approvedApplication: approvedApplication })), lenderName != 'Imprint' &&
                applicationServiceProviderPriority.productType == 'installment' && ((0, jsx_runtime_1.jsx)(ApprovalInstallment_1.default, { personalInfo: personalInfo, practice: practice, approvedApplication: approvedApplication }))] }));
}
function mapStateToProps(state) {
    return {
        approvedApplication: reducer_1.selectors.approvedApplication(state),
        practice: reducer_1.selectors.practice(state),
        personalInfo: reducer_1.selectors.personalInfo(state),
        lenderName: reducer_1.selectors.lenderName(state),
    };
}
const mapDispatchToProps = {};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(Approval);
